import classNames from '../../../../../../_virtual/index.mjs';
import React__default from 'react';
import modules_51b5745b from './CodeContainer.module.css.mjs';

const CodeContainer = ({ children, className, ...props })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classNames(className, modules_51b5745b.container),
        ...props
    }, children);

export { CodeContainer as default };
//# sourceMappingURL=CodeContainer.mjs.map
